import AddRole from './add';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import List from './list';
import AnalyzeMobileSection from '../../../atoms/creator/analyzeMobileSection';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F0F0F0',
    minHeight: '100%',
    padding: theme.spacing(3),
    paddingBottom: 100
  },
  btn: {
    margin: 8
  }
}));
export default function AdminRoleList() {
  document.title = "Admin Roles"
  const classes = useStyles();
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <>
      {!isMobileDevice ?
        <div className={classes.root}>
          <AddRole />
          <List />
        </div> :
        <AnalyzeMobileSection page={true} />}
    </>
  )
}
